module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "record-list"
  }, _vm._l((_vm.recordList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "flex-row-bc"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(((item.promotion_name) + "-" + (item.coupon_num) + "张" + (item.coupon_amount) + "元优惠券")))]), _vm._v(" "), _c('div', {
      staticClass: "price",
      class: item.order_status === 0 ? 'c-FF4A61' : ''
    }, [_vm._v("¥"), _c('span', [_vm._v(_vm._s(item.payment_amount))])])]), _vm._v(" "), (item.order_status === 0) ? _c('div', {
      staticClass: "flex-row-bc",
      staticStyle: {
        "padding-top": ".2rem"
      }
    }, [_c('div'), _vm._v(" "), _c('div', {
      staticClass: "c-FF4A61"
    }, [_vm._v("待支付")])]) : _vm._e(), _vm._v(" "), (item.order_status === 0) ? _c('div', {
      staticClass: "flex-row-bc",
      staticStyle: {
        "padding-top": ".2rem"
      }
    }, [_c('div', [_vm._v(_vm._s(item.order_date) + "自动取消")]), _vm._v(" "), _c('div', {
      staticClass: "btns"
    }, [_c('div', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.cancelOrder(item.order_id)
        }
      }
    }, [_vm._v("取消订单")]), _vm._v(" "), _c('div', {
      staticClass: "btn btn-pay",
      on: {
        "click": function($event) {
          return _vm.toPay(item)
        }
      }
    }, [_vm._v("继续支付")])])]) : _c('div', {
      staticClass: "flex-row-bc",
      staticStyle: {
        "padding-top": ".2rem"
      }
    }, [_c('div', [_vm._v(_vm._s(item.created_at))]), _vm._v(" "), _c('div', {
      staticClass: "c-999"
    }, [_vm._v(_vm._s(item.order_statusTips))])])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-391fff43","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/CouponPackageRecord.vue
// module id = 426
// module chunks = 7